export default "__VITE_ASSET__BpwjBZTJ__"